import { render, staticRenderFns } from "./TrainingMode.vue?vue&type=template&id=b4485284"
import script from "./TrainingMode.vue?vue&type=script&lang=js"
export * from "./TrainingMode.vue?vue&type=script&lang=js"
import style0 from "./TrainingMode.vue?vue&type=style&index=0&id=b4485284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports